import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a7c31c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wind" }
const _hoisted_2 = { class: "wind-bearing" }
const _hoisted_3 = ["title"]

import { toRefs } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { IWeather } from '@/types/workouts'
  import { convertDegreeToDirection } from '@/utils/weather'

  interface Props {
    weather: IWeather
    useImperialUnits: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    weather: null,
    useImperialUnits: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    weather: IWeather
    useImperialUnits: boolean
  }

  

  const { useImperialUnits, weather } = toRefs(props)
  const { t } = useI18n()

  function getWindDirectionTitle(windBearing: number): string {
    return t(
      `workouts.WEATHER.WIND_DIRECTIONS.${convertDegreeToDirection(
        windBearing
      )}`
    )
  }

return (_ctx: any,_cache: any) => {
  const _component_Distance = _resolveComponent("Distance")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Distance, {
      distance: _unref(weather).wind,
      unitFrom: "m",
      digits: 1,
      displayUnit: false,
      useImperialUnits: _unref(useImperialUnits)
    }, null, 8, ["distance", "useImperialUnits"]),
    _createTextVNode(" " + _toDisplayString(_unref(useImperialUnits) ? 'ft' : 'm') + "/s ", 1),
    _createElementVNode("div", _hoisted_2, [
      (_unref(weather).windBearing)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fa fa-long-arrow-down",
            style: _normalizeStyle({
          transform: `rotate(${_unref(weather).windBearing}deg)`,
        }),
            "aria-hidden": "true",
            title: getWindDirectionTitle(_unref(weather).windBearing)
          }, null, 12, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})